module.exports = __webpack_public_path__ + "static/media/home.15e49de1.svg";